import React from "react";
import MagicalAnimation from "../animations/magito/MagicalAnimation";

interface LoaderProps {}

const LoadingFluxi: React.FC<LoaderProps> = () => {
  return (
    <div className="flex flex-col justify-center items-center  h-screen ">
      {/* <l-quantum size="150" speed="2.5" color="#6c7ff5"></l-quantum> */}
      <div className="flex justify-center items-center h-[250px]">
        <MagicalAnimation />
      </div>
      <h2 className="text-2xl font-bold mt-12 text-gray-500">
        We are making magic with AI just for you
      </h2>
    </div>
  );
};

export default LoadingFluxi;
